<template>
    <div class="container">
        <!-- 滑动文字区域 -->
        <img class="img_top" src="@/assets/lachines_bg.png">
        <div class="scrollable-text">

            <div class="invation_class">
                <p class="invaitaion_class_top">{{ invitationCode }}</p>
                <p class="invaitaion_class_btm">邀请码</p>
            </div>

            <div>
                <div class="rule_top_wai_class">
                    <p class="rule_top_text_class"><img src="@/assets/powerpoint.png">&nbsp;&nbsp;活动内容:</p>
                    <div class="rule_top_wai_class_div_p">
                        <p class="rule_top_wai_class_p">
                            1、邀请新用户<br>
                            2、新用户使用验证码登录时填写您的邀请码，新用户登录成功后，赠送您1天会员;<br>
                            3、新用户首充会员后，赠送您5天会员。<br>
                        </p>
                    </div>
                </div>
                <div class="rule_top_wai_class">
                    <p class="rule_top_text_class"><img src="@/assets/powerpoint.png">&nbsp;&nbsp;活动规则:</p>
                    <div class="rule_top_wai_class_div_p">
                        <p class="rule_top_wai_class_p">
                            1、不限制邀请数量，邀请的新用户越多，赠送的会员越多;<br>
                            2、新用户首充“会员”才会赠送您5天会员，只限“首次'和“会员”。
                        </p>
                    </div>
                </div>
            </div>


        </div>

        <div>
            <button class="fixed-button" @click="copyContact">
                <img src="@/assets/copy.png" alt="" class="copy-icon"> <!-- 图片 -->
                <span v-if="invitationCode && invitationCode !== '未登录'">复制 {{ invitationCode }}</span> <!-- 邀请码 -->
                <span v-else>复制</span> <!-- 如果没有邀请码或为 nologin，则显示默认文本 -->
            </button>

        </div>


    </div>
</template>

<script>
import axios from 'axios'
import { ElMessage } from 'element-plus';
const baseURLA = (() => {
  const { hostname, protocol } = window.location;
  console.log(hostname)
  console.log(protocol)
  return '/api'; 
})();
axios.defaults.baseURL = baseURLA
// axios.defaults.baseURL = process.env.VUE_APP_URL
export default {
    created() {
        document.title = "邀新有礼"
        if (this.judgeClient() === "Android") {
            this.getAT()
        } else {
            this.getFromWebView()

            window.addEventListener("IosFound", this.handleMessage);

            window.handleMessage = this.handleMessage;
        }
    },
    deactivated() {
        // 在组件销毁时移除事件监听器，以防止内存泄漏
        window.removeEventListener("IosFound", this.handleMessage);
    },
    data() {
        return {
            invitationCode: "",//为nologin 视为未登录
            token: null
        };
    },

    methods: {
        handleChange(val) {
            console.log(val);
        },
        copyContact() {
            if (this.invitationCode == "未登录") {
                ElMessage.info("您还未登录哦");
                return
            }
            const textArea = document.createElement("textarea");
            textArea.value = this.invitationCode;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand("Copy");
            document.body.removeChild(textArea);
            ElMessage.success("复制成功")


        },
        getFromWebView() {
            if (window.webkit && window.webkit.messageHandlers) {


                window.webkit.messageHandlers.IosFound.postMessage("getToken");

            } else {
                this.nologin()

                ElMessage.error("window.webkit is not defined or missing messageHandlers");
            }
        },


        getAT() {
            this.token = window.android.getToken("")
            if (this.token == "") {
                ElMessage.info("您还未登录哦");
                this.nologin()
            } else {
                // ElMessage.success(this.token);
                this.getUserInfo()
            }
        },
        nologin(){
            this.invitationCode = "未登录"
        },
        handleMessage(event) {
            // 处理从 WebView 接收到的消息

            // ElMessage.success(event.data.token);
            this.token = event.data.token
            if (this.token == "") {
                ElMessage.info("您还未登录哦");
                this.nologin()
            } else {
                // ElMessage.success(this.token);
                this.getUserInfo()
                
            }
            // 根据你的实际需求进行处理，例如更新组件状态等
           
        },

        judgeClient() {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
            let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
            console.log('是否是Android：' + isAndroid); //true,false
            console.log('是否是iOS：' + isIOS);
            if (isAndroid) {
                return 'Android';
            } else if (isIOS) {
                return 'IOS';
            } else {
                return 'PC';
            }
        },
        async getUserInfo() {
            try {

       
                const res = await axios.post('/user/query', {

                }, {
                    headers: {

                        'Content-Type': 'application/json', // 设置请求头部
                        'Token': this.token,
                        'Channel': 'Web',
                        'Platform': 'Web',
                        'Device-Info': 'Web',
                        'App-Version-Code': '1.0.0',
                        'App-Version-Name': '1',
                    }
                })

                if (res.data.code === 200) {
                    // ElMessage.success(res.data.data.invitationCode); // 成功提示
                    this.invitationCode = res.data.data.invitationCode
                } else {
                    ElMessage.warning(res.data.msg); // 错误提示
                }
                // this.responseData = JSON.stringify(res.data.data)

            } catch (error) {
                console.error('Error fetching data:', error)
            }
        }

    },

}
</script>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}

.scrollable-text {
    flex-grow: 1;
    overflow-y: auto;
    padding: 20px;
}

.scrollable-text p {
    text-align: left;
    /* 将文本左对齐 */
    margin: 0;
    /* 移除默认的段落边距 */
}

.img_top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -1;
}

.invation_class {
    width: 90%;
    height: 68px;
    border-radius: 50px;
    background-color: #F5F5F5;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 216px auto 20px auto;
    /* 50px 的顶部边距，20px 的底部边距 */
}


.invaitaion_class_top {
    font-size: 25px;
    color: #000000;
}

.invaitaion_class_btm {
    font-size: 12px;
    color: #666666;
    font-weight: normal;
    /* 设置字体为 Regular */

}

.rule_top_wai_class {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    /* 从左侧开始对齐 */
    text-align: left;
    /* 让内部文本左对齐 */
    margin-top: 30px;

}

.rule_top_wai_class_div_p {
    font-size: 12px;
    color: #666666;
    font-weight: normal;
    /* 设置字体为 Regular */
    margin-left: 15px;
    margin-top: 12px;
}


.rule_top_text_class {
    justify-content: center;
    align-items: center;
    /* 垂直居中 */
    justify-content: flex-start;
    /* 从左侧开始对齐 */
    text-align: left;
    /* 让内部文本左对齐 */
    height: 30px;
    /* 设置容器的高度 */
    line-height: 30px;
    /* 使内容垂直居中 */
    font-size: 14px;
    color: #252525;
}

.rule_top_text_class img {
    width: 8px;
    height: 8px;
    margin-top: 15px;
    /* 调整图片和文字之间的间距 */

}

.fixed-button {
    width: 90%;
    height: 50px;
    margin-bottom: 20px;
    border-radius: 12px;
    font-size: 16px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #323641;
    color: #fff;
    font-weight: normal;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fixed-button .copy-icon {
    width: 14px;
    height: 16px;
    margin-right: 10px;
    /* 图片与文字之间的间距 */
}
</style>
